import { render, staticRenderFns } from "./One.vue?vue&type=template&id=44520cf9"
import script from "./One.vue?vue&type=script&lang=ts"
export * from "./One.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports